import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { parentApi, kidApi, PARENT_KEY, KID_KEY } from "../lib/api";

const AuthCtx = createContext(null);
const UNLOCK_KEY = "zunii_parent_unlocked";

export function AuthProvider({ children }) {
  const [parent, setParent] = useState(null); // null=checking, false=none
  const [kid, setKid] = useState(localStorage.getItem(KID_KEY) ? undefined : null); // undefined=restoring
  const [unlocked, setUnlocked] = useState(sessionStorage.getItem(UNLOCK_KEY) === "1");

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setKid(null);
      return setParent(false);
    }
    if (!localStorage.getItem(PARENT_KEY)) {
      setKid(null);
      return setParent(false);
    }
    parentApi.get("/auth/me").then((r) => setParent(r.data)).catch(() => {
      localStorage.removeItem(PARENT_KEY);
      setParent(false);
    });
    if (localStorage.getItem(KID_KEY)) {
      kidApi.get("/kid/me").then((r) => setKid(r.data)).catch(() => {
        localStorage.removeItem(KID_KEY);
        setKid(null);
      });
    }
  }, []);

  const loginParent = useCallback((data) => {
    localStorage.setItem(PARENT_KEY, data.token);
    localStorage.removeItem(KID_KEY);
    sessionStorage.setItem(UNLOCK_KEY, "1");
    setUnlocked(true);
    setKid(null);
    setParent(data.user);
  }, []);

  const lockParent = useCallback(() => {
    sessionStorage.removeItem(UNLOCK_KEY);
    setUnlocked(false);
  }, []);

  const unlockParent = useCallback(() => {
    sessionStorage.setItem(UNLOCK_KEY, "1");
    setUnlocked(true);
  }, []);

  const loginKid = useCallback((data) => {
    localStorage.setItem(KID_KEY, data.token);
    sessionStorage.removeItem(UNLOCK_KEY);
    setUnlocked(false);
    setKid(data.kid);
  }, []);

  const logoutKid = useCallback(() => {
    localStorage.removeItem(KID_KEY);
    setKid(null);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem(PARENT_KEY);
    localStorage.removeItem(KID_KEY);
    sessionStorage.removeItem(UNLOCK_KEY);
    setKid(null);
    setParent(false);
  }, []);

  const refreshParent = useCallback(() => {
    if (!localStorage.getItem(PARENT_KEY)) return;
    parentApi.get("/auth/me").then((r) => setParent(r.data)).catch(() => {});
  }, []);

  return (
    <AuthCtx.Provider value={{ parent, kid, setKid, unlocked, loginParent, lockParent, unlockParent, loginKid, logoutKid, logout, refreshParent }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
